module.exports = __webpack_public_path__ + "media/打卡四建.0396a253.mp3";